import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ISettlementTransaction,
  ISettlementTransactionPagedResponse,
} from '../../interfaces/settlement/settlement-transaction.interface';
import { AbstractSettlementService } from '../abstraction/abstract.settlement.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MockSettlementService extends AbstractSettlementService {
  private getTransactionsByRespondentAndCycleJson =
    'assets/mocks/settlement/getTransactionsByRespondentAndCycle.json';

  constructor(private http: HttpClient) {
    super();
  }

  getTransactionsByRespondentAndCycle(
    respondentRtn: string,
    cycleDate: string
  ): Promise<ISettlementTransaction[] | undefined> {
    return lastValueFrom(
      this.http.get<ISettlementTransaction[]>(this.getTransactionsByRespondentAndCycleJson)
    );
  }

  async getTransactionsByRespondentAndCyclePaged(
    respondentRtn: string,
    cycleDate: string,
    page: number,
    pageSize: number,
    sortBy: string,
    sortAsc: boolean,
    filterText: string
  ): Promise<ISettlementTransactionPagedResponse | undefined> {
    const all = await lastValueFrom(
      this.http.get<ISettlementTransaction[]>(this.getTransactionsByRespondentAndCycleJson)
    );
    const items = all ?? [];
    const start = (page - 1) * pageSize;
    const paged = items.slice(start, start + pageSize);
    return {
      queryable: paged,
      rowCount: items.length,
      pageCount: Math.ceil(items.length / pageSize),
      pageSize: pageSize,
      currentPage: page,
    };
  }
}
